/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Brain_DescriptionInputs */

const es_walkthrough_brain_description = /** @type {(inputs: Walkthrough_Brain_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activá el razonamiento avanzado para un análisis más profundo. Cuando está activo, Nexy usa un modelo de pensamiento extendido. Esto cuenta como dos mensajes.`)
};

const en_walkthrough_brain_description = /** @type {(inputs: Walkthrough_Brain_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable advanced reasoning for deeper analysis. When active, Nexy uses an extended thinking model. This counts as two messages.`)
};

/**
* | output |
* | --- |
* | "Enable advanced reasoning for deeper analysis. When active, Nexy uses an extended thinking model. This counts as two messages." |
*
* @param {Walkthrough_Brain_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_brain_description = /** @type {((inputs?: Walkthrough_Brain_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Brain_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_brain_description(inputs)
	return en_walkthrough_brain_description(inputs)
});
export { walkthrough_brain_description as "walkthrough.brain_description" }